import React from 'react';
import { useProductQuantity } from '../hooks/useProductQuantity';

const QuantitySelectorTitle = () => {
	const { blockClass } = useProductQuantity();

	const renderClass = () => blockClass && `vtex-product-quantity-1-x-quantitySelectorTitle--${blockClass}`;

	return (
		<div
			className={`quantitySelectorTitle quantitySelectorTitle--${blockClass} vtex-product-quantity-1-x-quantitySelectorTitle ${renderClass()} mb3 c-muted-2 t-body`}
		>
			Quantidade
		</div>
	);
};

export default QuantitySelectorTitle;
